import {
    StyleFunction,
    useAuth,
    useForm,
    useThemedStyle,
} from "@venuepos/react-common";
import { GQApprovalInput, useApprovalCreateMutation } from "graphql-sdk";
import { defaultApproval, schemaApproval } from "lib";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import { useHandleMutationError } from "../../../../hooks";
import { RootStackScreenProps } from "../../../../navigation";
import { AdminContainer } from "../../../container";
import { Form } from "../form";

type ScreenProps = RootStackScreenProps<"APPROVAL_CREATE">;

export function ApprovalCreateScreen({
    navigation: { navigate },
}: ScreenProps) {
    const auth = useAuth();
    auth.enforce("merchant.approval");

    const [t] = useTranslation();
    const [approvalCreate] = useApprovalCreateMutation();
    const form = useForm<GQApprovalInput>(schemaApproval, defaultApproval);

    const [{ values }, { reset }] = form;
    const styles = useThemedStyle(styleFunc);
    const { handleMutationError } = useHandleMutationError();

    const handleCreate = useCallback(async () => {
        if (!values) {
            return;
        }

        await handleMutationError(
            async () =>
                await approvalCreate({
                    variables: {
                        approval: {
                            type: values.type,
                            active: values.active,
                            tokenIds: values.tokenIds,
                            tokenGroupIds: values.tokenGroupIds,
                        },
                    },
                }),
            t("common.saved", "Saved"),
            () => {
                reset();
                navigate("APPROVALS", { refetch: true });
            }
        );
    }, [values, handleMutationError, t, approvalCreate, reset, navigate]);

    return (
        <AdminContainer>
            <View>
                <View style={styles.formBox}>
                    <Form
                        form={form}
                        onSubmit={handleCreate}
                        submitButton={["common.save", "Save"]}
                    />
                </View>
            </View>
        </AdminContainer>
    );
}

const styleFunc: StyleFunction = theme => ({
    formBox: {
        maxWidth: theme.dimensions.maxFormWidth,
    },
});
